import template from './optionSwitch.html';
import controller from './optionSwitch.controller';
import './optionSwitch.scss';

let optionSwitchComponent = {
  restrict: 'E',
  bindings: {
    optionsData: '<',
    onSelect : '&',
    lockOn: '<',
    editable: '<',
    autoReturnDefaultOption:'<',
    selectedOption: '<'
  },
  template,
  controller
};

export default optionSwitchComponent;



// WEBPACK FOOTER //
// ./client/app/components/optionSwitch/optionSwitch.component.js